import Hashids from "hashids";

const hashWithKey = new Hashids("d161t4lSTEREO", 6);
const hashWithoutKey = new Hashids("", 6);

const encodeWithKey = (id) => {
  if (!id) return null;
  return hashWithKey.encode(id);
};

const decodeWithKey = (encodedId) => {
  if (!encodedId) return null;
  return hashWithKey.decode(encodedId)[0];
};

const encodeWithoutKey = (id) => {
  if (!id) return null;
  return hashWithoutKey.encode(id);
};

const decodeWithoutKey = (encodedId) => {
  if (!encodedId) return null;
  return hashWithoutKey.decode(encodedId)[0];
};

const hashidsUtils = {
  encodeWithKey,
  decodeWithKey,
  encodeWithoutKey,
  decodeWithoutKey,
};

export default hashidsUtils;
